import { render } from "./SkeletonCategorie.vue?vue&type=template&id=160ea22b&scoped=true"
import script from "./SkeletonCategorie.vue?vue&type=script&lang=js"
export * from "./SkeletonCategorie.vue?vue&type=script&lang=js"

import "@/assets/categorie.css?vue&type=style&index=0&id=160ea22b&scoped=true&lang=css"
import "@/assets/skeletonCategorie.css?vue&type=style&index=1&id=160ea22b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-160ea22b"

export default script